import { render, staticRenderFns } from "./FileIconStatus.vue?vue&type=template&id=6e9f3470&"
import script from "./FileIconStatus.vue?vue&type=script&lang=js&"
export * from "./FileIconStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports